import React, { useEffect, useState } from "react";
import WorkCard from "../WorkCard";
import styles from "./styles.module.css";
import type { WorkItem } from "../../types/work";

type Props = {
  items: WorkItem[];
  autoPlayMs?: number;
};

const WorksCarousel: React.FC<Props> = ({ items, autoPlayMs }) => {
  const [index, setIndex] = useState(0);

  useEffect(() => {
    if (!autoPlayMs) return;
    const timer = setInterval(() => {
      setIndex((i) => (i + 1) % items.length);
    }, autoPlayMs);
    return () => clearInterval(timer);
  }, [autoPlayMs, items.length]);

  // 画像の事前デコード（切替時のちらつき防止）
  useEffect(() => {
    let cancelled = false;
    const preload = async () => {
      for (const it of items) {
        if (cancelled) break;
        try {
          const img = new Image();
          img.decoding = "async" as any;
          img.src = it.image;
          if (img.decode) {
            await img.decode().catch(() => {});
          }
        } catch {
          // noop
        }
      }
    };
    preload();
    return () => {
      cancelled = true;
    };
  }, [items]);

  return (
    <div className={styles.carousel}>
      <div className={styles.fadeViewport}>
        {items.map((w, i) => (
          <div
            key={w.title}
            className={`${styles.slide} ${i === index ? styles.active : ""}`}
            aria-hidden={i === index ? undefined : true}
          >
            <WorkCard
              title={w.title}
              image={w.image}
              tags={w.tags}
              period={w.period}
              description={w.description}
              officialUrl={w.officialUrl}
              officialUrlLabel={w.officialUrlLabel}
              hashtag={w.hashtag}
              imageLoading={i === 0 ? "eager" : "lazy"}
              imageDecoding="async"
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default WorksCarousel;
